import React, { useEffect, useState } from "react";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { brandGames } from "../../../../lib/data/brandGames.data";
import Poker from "../../../../assets/images/home-casino/Poker.webp";
import MayanRichesRockways from "../../../../assets/images/home-casino/MayanRichesRockways.webp";
import CrossFireChickenx5000 from "../../../../assets/images/home-casino/CrossFireChickenx5000.webp";
import GoldenMirageRoulette from "../../../../assets/images/home-casino/GoldenMirageRoulette.webp";
import LuckyChickenCrossing from "../../../../assets/images/home-casino/LuckyChickenCrossing.webp";
import RuletaAmazonica from "../../../../assets/images/home-casino/RuletaAmazonica.webp";
import Slider from "react-slick";

function Brandgames() {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(Object.values(brandGames));
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 900000,
    speed: 800,
    swipe: false,
    draggable: false,
    touchMove: false,
    pauseOnHover: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="prvdr-game-page brand-games">
          <div className="spotlight">
            <h6>In the spotlight</h6>

            <Slider {...settings}>
              <div>
                <div className="game">
                  <a href="/casino/jt-poker">
                    <img src={Poker} alt="Poker" />
                  </a>
                </div>
              </div>
              <div>
                <div className="game">
                  <a href="/casino/qt-mayan-riches-rockways">
                    <img
                      src={MayanRichesRockways}
                      alt="mayan riches rockways"
                    />
                  </a>
                </div>
              </div>
              <div>
                <div className="game">
                  <a href="/casino/jt-154912">
                    <img
                      src={CrossFireChickenx5000}
                      alt="Cross Fire Chicken x5000"
                    />
                  </a>
                </div>
              </div>
              <div>
                <div className="game">
                  <a href="/casino/jt-golden-mirage-roulette">
                    <img
                      src={GoldenMirageRoulette}
                      alt="Golden Mirage Roulette"
                    />
                  </a>
                </div>
              </div>
              <div>
                <div className="game">
                  <a href="/casino/jt-140511">
                    <img
                      src={LuckyChickenCrossing}
                      alt="Lucky Chicken Crossing"
                    />
                  </a>
                </div>
              </div>
              <div>
                <div className="game">
                  <a href="/casino/jt-ruleta-amazonica">
                    <img src={RuletaAmazonica} alt="Ruleta Amazonica" />
                  </a>
                </div>
              </div>
            </Slider>
          </div>

          <div className="brand-games-list mt-5">
            <h6>Yildiztop games</h6>
            <ul className="gamelisting">
              {filteredData.length > 0 ? (
                filteredData.map((game, idx) => (
                  <li key={game.code || idx} className="game-item">
                    <a href={game.href || "javascript:void(0)"}>
                      <div className="img-box">
                        <img src={game.imgUrl} alt={game.name || ""} />
                        <div className="overlay">
                          <div className="play-btn">Play</div>
                        </div>
                      </div>
                      <p className="name">{game.name}</p>
                    </a>
                  </li>
                ))
              ) : (
                <li>No games available</li>
              )}
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default Brandgames;
